import { apiClient } from '../api-client'
import { Notification, PaginatedResponse } from '@/types'

// Notifications API
export const notificationsApi = {
  getNotifications: async (
    filters?: { page?: number; limit?: number; unreadOnly?: boolean; read?: boolean; category?: string }
  ): Promise<PaginatedResponse<Notification>> => {
    const page = filters?.page ?? 1
    const limit = filters?.limit ?? 20
    const unreadOnly = filters?.unreadOnly ?? filters?.read === false
    const skip = (page - 1) * limit

    const rows = await apiClient.get('/notifications', {
      params: { unread_only: unreadOnly, skip, limit }
    })

    const data: Notification[] = (rows || []).map((row: any) => ({
      // Prefer explicit action URL from backend, then infer entity link metadata.
      id: String(row.id),
      type: String(row.event_type || row.category || 'system_event'),
      category: String(row.category || 'system'),
      eventType: String(row.event_type || 'system_event'),
      actionUrl: row.action_url || undefined,
      relatedType:
        row?.metadata?.task_id ? 'task' :
        row?.metadata?.bug_id ? 'bug' :
        row?.metadata?.ticket_id ? 'ticket' :
        row?.metadata?.project_id ? 'project' :
        row?.metadata?.milestone_id ? 'milestone' :
        undefined,
      title: row.title,
      message: row.message,
      read: Boolean(row.read_at) || row.status === 'read',
      userId: String(row.recipient_id),
      relatedId:
        row?.metadata?.task_id ||
        row?.metadata?.bug_id ||
        row?.metadata?.ticket_id ||
        row?.metadata?.project_id ||
        row?.metadata?.milestone_id,
      createdAt: row.created_at
    }))

    const filtered = filters?.category && filters.category !== 'all'
      ? data.filter((item) => String(item.category || '').toLowerCase() === String(filters.category).toLowerCase())
      : data

    return {
      data: filtered,
      total: filtered.length,
      page,
      limit,
      totalPages: Math.max(1, Math.ceil(filtered.length / limit))
    }
  },

  markAsRead: (id: string): Promise<void> =>
    apiClient.patch(`/notifications/${id}/read`),

  markAllAsRead: (): Promise<void> =>
    apiClient.patch('/notifications/read-all'),

  deleteNotification: (id: string): Promise<void> =>
    apiClient.delete(`/notifications/${id}`),

  clearAllNotifications: (): Promise<{ message: string; count: number }> =>
    apiClient.delete('/notifications/clear-all'),

  getUnreadCount: (): Promise<{ count: number }> =>
    apiClient.get('/notifications/unread-count'),
}
